document.addEventListener("DOMContentLoaded", () => {
  const floatingBanner = document.querySelector(".js-floating-banner");
  const footer = document.querySelector("#shopify-section-footer");
  const floatingBannerClose = document.querySelector(".js-floating-banner-close");

  if (!floatingBanner) return;

  let closedFlg = false;
  let isFooterVisible = false;
  let isBannerVisible = false;

  floatingBanner.style.display = "none";
  floatingBanner.style.opacity = "0";
  floatingBanner.style.transition = "opacity 0.5s";

  const showBanner = () => {
    if (isBannerVisible) return;
    isBannerVisible = true;
    floatingBanner.style.display = "block";

    requestAnimationFrame(() => {
      floatingBanner.style.opacity = "1";
    });
  };

  const hideBanner = () => {
    if (!isBannerVisible) return;
    isBannerVisible = false;
    floatingBanner.style.opacity = "0";

    setTimeout(() => {
      if (!isBannerVisible) {
        floatingBanner.style.display = "none";
      }
    }, 500);
  };

  const updateBannerVisibility = () => {
    if (closedFlg) {
      hideBanner();
      return;
    }

    if (window.scrollY > 100 && !isFooterVisible) {
      showBanner();
    } else {
      hideBanner();
    }
  };

  window.addEventListener("scroll", updateBannerVisibility);

  if (footer) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isFooterVisible = entry.isIntersecting;
      });
      updateBannerVisibility();
    });

    observer.observe(footer);
  }

  if (floatingBannerClose) {
    floatingBannerClose.addEventListener("click", () => {
      closedFlg = true;
      hideBanner();
    });
  }
});